export default "__VITE_ASSET__DqZZWWh2__"